/**
 * SubMenuItem — modul ve vyskakovacím panelu sekce (desktop).
 *
 * Ikona v malém podbarveném čtverečku v barvě sekce, název, vpravo počet
 * (nepodepsané směrnice, nedokončená školení…). Otevřený modul je podbarvený.
 *
 * @param {Object} props
 * @param {Object} props.item - { id, label, Icon }
 * @param {boolean} props.active
 * @param {string} props.accentColor
 * @param {number} [props.badge]
 * @param {boolean} props.isDark
 * @param {() => void} props.onClick
 */
export default function SubMenuItem({
    item,
    active,
    accentColor,
    badge = 0,
    isDark = true,
    onClick,
}) {
    const Icon = item.Icon;
    const hover = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.045)';
    // Modul, který se teprve staví, zůstává v panelu (kdo ho má přidělený, ať
    // ví, že přijde), ale neotevře se — jinak za ním člověk najde prázdno.
    const ceka = item.pripravovany;

    return (
        <button
            type="button"
            role="menuitem"
            onClick={ceka ? undefined : onClick}
            disabled={ceka}
            style={{
                ...(ceka ? { opacity: 0.5, cursor: 'default' } : null),
                display: 'flex', alignItems: 'center', gap: 10,
                width: '100%', minHeight: 38,
                padding: '5px 8px',
                borderRadius: 6, border: 'none', cursor: 'pointer', textAlign: 'left',
                background: active ? `${accentColor}1f` : 'transparent',
                color: active ? accentColor : 'var(--text-primary)',
                font: 'inherit',
                transition: 'background 0.12s ease',
            }}
            onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = hover; }}
            onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = 'transparent'; }}
        >
            <span
                aria-hidden="true"
                style={{
                    width: 28, height: 28, borderRadius: 6, flexShrink: 0,
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    background: `${accentColor}${active ? '33' : '1a'}`, color: accentColor,
                }}
            >
                <Icon size={15} strokeWidth={2} />
            </span>
            <span style={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: active ? 600 : 500, lineHeight: 1.2 }}>
                {item.label}
            </span>
            {ceka && (
                <span style={{
                    flexShrink: 0, fontSize: 9.5, fontWeight: 600, letterSpacing: 0.3,
                    textTransform: "uppercase", color: "var(--text-muted)",
                }}>
                    Připravujeme
                </span>
            )}
            {badge > 0 && (
                <span
                    style={{
                        minWidth: 18, height: 18, padding: '0 5px', flexShrink: 0,
                        background: '#FF8A00', color: '#fff',
                        fontSize: 10, fontWeight: 700, borderRadius: 999,
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    }}
                >
                    {badge > 9 ? '9+' : badge}
                </span>
            )}
        </button>
    );
}
